import React from 'react';
import { Box, Typography } from '@mui/material';

const WelcomeSpreadFooter: React.FC = () => {
  return (
    <>
      <Box sx={{ height: 60 }} aria-hidden="true" />
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: 60,
          zIndex: 50,
          backgroundColor: 'transparent',
          borderTop: `1px solid #C1B6AD`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            color: '#A89B91',
            fontSize: '1rem',
            fontWeight: 500,
          }}
        >
          Hello World
        </Typography>
      </Box>
    </>
  );
};

export default WelcomeSpreadFooter;
